import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import "./MemberPrint.css";
import { getCurrentDateInIST, getCurrentTimeInIST } from "../../../utils/utils";

const BookingReceiptPrint = () => {
  const navigate = useNavigate();
  const ref = useRef();
  const memberDetails = JSON.parse(localStorage.getItem("memberDetails"));
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);

    const input = ref.current;
    const pdf = new jsPDF("p", "mm", "a4");
    const originalPdfWidth = pdf.internal.pageSize.getWidth();
    const originalPdfHeight = pdf.internal.pageSize.getHeight();
    const pdfWidth = originalPdfWidth * 0.9;
    const pdfHeight = originalPdfHeight * 0.9;
    const xOffset = (originalPdfWidth - pdfWidth) / 2;
    const yOffset = (originalPdfHeight - pdfHeight) / 2;
    const sections = input.querySelectorAll(".section");

    let heightLeft = pdfHeight;

    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];

      const canvas = await html2canvas(section, { useCORS: true, scale: 2 });
      const imgData = canvas.toDataURL("image/jpeg", 0.7);
      const imgProps = pdf.getImageProperties(imgData);
      const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

      if (
        heightLeft < imgHeight ||
        section.classList.contains("sanction-letter-section")
      ) {
        pdf.addPage();
        heightLeft = pdfHeight;
      }

      pdf.addImage(
        imgData,
        "JPEG",
        xOffset,
        yOffset + (pdfHeight - heightLeft),
        pdfWidth,
        imgHeight
      );
      heightLeft -= imgHeight;

      // Add border to the current page after content is added
      pdf.rect(5, 5, originalPdfWidth - 10, originalPdfHeight - 10); // Rect (x, y, width, height)
    }

    pdf.setProperties({
      title: "Document",
      subject: "Generated Document",
      author: "Your Name",
      keywords: "generated, javascript, web 2.0, ajax",
      creator: "Your App",
    });

    pdf.save(`${memberDetails.memberDetails.memberName}-Booking-Receipt`);
    setLoading(false);
  };

  return (
    <div>
      <div className="button-container">
        <button
          className="btn btn-success"
          onClick={handleDownload}
          disabled={loading}
        >
          {loading ? "Downloading..." : "Download PDF"}
        </button>
      </div>

      <div
        ref={ref}
        className="print-container"
        style={{
          maxHeight: "calc(100vh - 60px)",
          overflowY: "auto",
          padding: "20px",
          margin: "0 auto",
          backgroundColor: "white",
        }}
      >
        <div className="section">
          <div className="header-grid">
            <h1 className="header-title">Gold Booking Receipts</h1>
            <div className="header-logo">
              <img
                src={require("../../../assets/vetrivikaslogo.jpeg")}
                alt="logo"
                className="printlogo"
              />
            </div>
          </div>

          <table
            className="receipt-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "20px",
            }}
          >
            <tbody>
              <tr>
                <th
                  style={{
                    border: "1px solid black",
                    padding: "8px",
                    width: "25%",
                  }}
                >
                  Branch
                </th>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "8px",
                    width: "25%",
                  }}
                >
                  {memberDetails.branchName}
                </td>
                <th
                  style={{
                    border: "1px solid black",
                    padding: "8px",
                    width: "25%",
                  }}
                >
                  Booking date
                </th>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "8px",
                    width: "25%",
                  }}
                >
                  {getCurrentDateInIST()}
                </td>
              </tr>
              <tr>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Customer Name
                </th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.memberDetails.memberName}
                </td>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Booking Time
                </th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {getCurrentTimeInIST()}
                </td>
              </tr>
              <tr>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Address
                </th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.memberDetails.permanentDoorNo +
                    "," +
                    memberDetails.memberDetails.permanentStreetNo +
                    "," +
                    memberDetails.memberDetails.permanentPanchayat}
                </td>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Booking Day Gold Rate
                </th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.bookingProcessDetails.goldRate}
                </td>
              </tr>
              <tr>
                <th style={{ border: "1px solid black", padding: "8px" }}></th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.memberDetails.permanentTaluk}
                </td>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Ornament Name
                </th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.bookingProcessDetails.ornamentName}
                </td>
              </tr>
              <tr>
                <th style={{ border: "1px solid black", padding: "8px" }}></th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.memberDetails.permanentDistrict}
                </td>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Ornament Model No
                </th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.bookingProcessDetails.ornamentModelNo}
                </td>
              </tr>
              <tr>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Pincode
                </th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.memberDetails.permanentPincode}
                </td>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Booking Amount
                </th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.bookingProcessDetails.bookingAmount}
                </td>
              </tr>
              <tr>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Mobile No
                </th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.memberDetails.phoneNumber}
                </td>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Delivery expected
                </th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  15 days
                </td>
              </tr>
              <tr>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Alternative no
                </th>
                <td style={{ border: "1px solid black", padding: "8px" }}></td>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  ROI
                </th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.proposedLoanDetails.rateOfInterest}
                </td>
              </tr>
              <tr>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  LAN No
                </th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.memberDetails.ApplicationId}
                </td>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Tenure
                </th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.proposedLoanDetails.tenureInMonths}
                </td>
              </tr>
              <tr>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Nominee Name
                </th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.coApplicantDetails.coApplicantName}
                </td>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Nominee relationship
                </th>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.coApplicantDetails.relation}
                </td>
              </tr>
            </tbody>
          </table>

          <table
            className="calculation-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "20px",
            }}
          >
            <thead>
              <tr>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  S.No
                </th>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Particulars
                </th>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Count
                </th>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: "1px solid black", padding: "8px" }}>1</td>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  Gram
                </td>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.bookingProcessDetails.ornamentWeight}
                </td>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.bookingProcessDetails.ornamentWeightValue}
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid black", padding: "8px" }}>2</td>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  Wastage
                </td>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.bookingProcessDetails.wastage}
                </td>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.bookingProcessDetails.wastageValue}
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid black", padding: "8px" }}>3</td>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  Total
                </td>
                <td style={{ border: "1px solid black", padding: "8px" }}></td>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.bookingProcessDetails.total}
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid black", padding: "8px" }}>4</td>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  GST
                </td>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.bookingProcessDetails.gst}
                </td>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.bookingProcessDetails.gstValue}
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid black", padding: "8px" }}>5</td>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  Total
                </td>
                <td style={{ border: "1px solid black", padding: "8px" }}></td>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.bookingProcessDetails.grandTotal}
                </td>
              </tr>
            </tbody>
          </table>

          <div
            style={{
              marginTop: "20px",
              padding: "10px",
              border: "1px solid black",
            }}
          >
            <div>
              Booking Amount:{" "}
              <strong>
                {memberDetails.bookingProcessDetails.bookingAmount}
              </strong>
            </div>
          </div>

          <table
            className="denominations-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "20px",
            }}
          >
            <thead>
              <tr>
                <th
                  colSpan="3"
                  style={{ border: "1px solid black", padding: "8px" }}
                >
                  Denominations
                </th>
              </tr>
            </thead>
            <tbody>
              {memberDetails.denominations
                .sort((a, b) => b.denomination - a.denomination)
                .map((denom, index) => (
                  <tr key={index}>
                    <td style={{ border: "1px solid black", padding: "8px" }}>
                      {denom.denomination}
                    </td>
                    <td style={{ border: "1px solid black", padding: "8px" }}>
                      {denom.count}
                    </td>
                    <td style={{ border: "1px solid black", padding: "8px" }}>
                      {denom.denomination * denom.count}
                    </td>
                  </tr>
                ))}
              <tr>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  Total
                </td>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.denominations.reduce(
                    (sum, denom) => sum + denom.count,
                    0
                  )}
                </td>
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {memberDetails.denominations.reduce(
                    (sum, denom) => sum + denom.denomination * denom.count,
                    0
                  )}
                </td>
              </tr>
            </tbody>
          </table>

          <div
            style={{
              marginTop: "30px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>Customer Signature</div>
            <div>Manager Signature</div>
          </div>

          <table
            style={{
              width: "100%",
              marginTop: "20px",
              borderCollapse: "collapse",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    borderBottom: "none",
                    padding: "8px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  VETRIVIKAS CAPITAL
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    borderBottom: "none",
                    padding: "8px",
                  }}
                >
                  47/4 PTR TOWER 4TH FLOOR BYPASS ROAD,PONMENI (NEAR KUMAR MESS)
                  MADURAI - 625016
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    borderTop: "none",
                    padding: "8px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  TRUST
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    borderTop: "none",
                    padding: "8px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span>MOBILE NO: 9944855826</span>
                  <span>TELL: 04524909438</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BookingReceiptPrint;
